<app-navbar></app-navbar>

<!-- Page Banner -->
<div class="rs-page-banner">
  <div class="rs-pb-deco">
    <div class="rs-pb-dots"></div>
    <div class="rs-pb-circle rs-pb-c1"></div>
    <div class="rs-pb-circle rs-pb-c2"></div>
  </div>
  <div class="container">
    <div class="rs-pb-content">
      <h1 class="rs-pb-title">Photo Gallery</h1>
      <nav class="rs-pb-breadcrumb">
        <a routerLink="/">Home</a>
        <i class="ri-arrow-right-s-line"></i>
        <span>Photo Gallery</span>
      </nav>
    </div>
  </div>
</div>

<!-- Content -->
<div class="rs-inner-page">
  <div class="container">

    <!-- Loading -->
    <div *ngIf="fetchingData" class="rs-inner-skeleton"></div>

    <ng-container *ngIf="!fetchingData && mainResponse.length != 0">

      <!-- Breadcrumb nav -->
      <div class="rs-breadcrumb-nav" *ngIf="folders.length">
        <i class="ri-home-4-line" style="color:#d3363a;"></i>
        <a [routerLink]="['/photo-gallery']">Photo Gallery</a>
        <ng-container *ngFor="let path of folders; let last = last; trackBy: trackByFn2">
          <span class="rs-bc-sep"><i class="ri-arrow-right-s-line"></i></span>
          <ng-container *ngIf="!last">
            <a class="rs-bc-link" style="cursor:pointer;" (click)="Goto(path.id)">{{ path.name }}</a>
          </ng-container>
          <ng-container *ngIf="last">
            <span class="rs-bc-current">{{ path.name }}</span>
          </ng-container>
        </ng-container>
      </div>

      <!-- Sub-folders -->
      <div *ngIf="album.length != 0">
        <div class="rs-inner-section-title">
          <div class="rs-ist-sub"><i class="ri-folder-2-line"></i> Albums</div>
          <h2>Photo Albums</h2>
        </div>
        <div class="row g-3 mb-5">
          <div class="col-xl-3 col-lg-3 col-md-4 col-6 wow fadeIn"
               *ngFor="let albumItem of album; let i = index"
               [attr.data-wow-delay]="(i * 0.07 + 0.1) + 's'">
            <div class="rs-album-card" [routerLink]="['/imageFolder', albumItem.Id]">
              <div class="rs-album-thumb">
                <img *ngIf="getImageUrl(albumItem)"
                     [src]="getImageUrl(albumItem)" [alt]="albumItem?.Name"
                     (load)="onImageLoad()" (error)="onImageError($event, albumItem)">
                <div class="rs-album-thumb-icon" *ngIf="!getImageUrl(albumItem)">
                  <i class="ri-folder-image-line"></i>
                </div>
              </div>
              <div class="rs-album-body">
                <h5>{{ albumItem.Name }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Photo grid -->
      <div *ngIf="files.length !== 0">
        <div class="rs-inner-section-title">
          <div class="rs-ist-sub"><i class="ri-image-line"></i> Photos</div>
          <h2>All Photos</h2>
        </div>
        <div class="rs-gallery-grid">
          <div class="rs-gallery-grid-item wow fadeIn"
               *ngFor="let image of files; let i = index"
               [attr.data-wow-delay]="(i * 0.04) + 's'"
               (click)="openModal(i)">
            <img [src]="TransformUrl(image?.titleImageLink || image?.titleImagePath || image?.ImageLink || image?.ImagePath)"
                 [alt]="image?.name || image?.Name || 'Photo'" class="popup-btn">
          </div>
        </div>
      </div>

    </ng-container>

    <!-- No data -->
    <div *ngIf="!fetchingData && mainResponse.length == 0" class="rs-empty-state">
      <i class="ri-image-2-line"></i>
      <h4>No album data found</h4>
    </div>

  </div>
</div>

<!-- Image Modal -->
<div class="image-modal" *ngIf="isModalOpen" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="close-button" (click)="closeModal()">&#10005;</button>
    <button class="nav-button left" (click)="prevImage($event)">&#10094;</button>
    <img [src]="TransformUrl(files[currentIndex]?.titleImageLink || files[currentIndex]?.titleImagePath || files[currentIndex]?.ImageLink || files[currentIndex]?.ImagePath)"
         class="modal-image"
         [alt]="files[currentIndex]?.name || files[currentIndex]?.Name || 'Image'">
    <button class="nav-button right" (click)="nextImage($event)">&#10095;</button>
  </div>
</div>
